import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { GlobalStateProvider, GlobalStateContext } from './GlobalState';
import { BggList, BggPlay, SellerList, Research, BggTrade, Header, Footer } from './components';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { useContext } from 'react';

function AppContent() {
  const { isGridExpanded } = useContext(GlobalStateContext);

  return (
    <div className="App">
      <div id="modal-root"></div>
      {!isGridExpanded && <Header />}
      <Routes>
        <Route exact path="/" element={<BggList />} />
        <Route path="/play" element={<BggPlay />} />
        <Route path="/sell" element={<SellerList />} />
        <Route path="/research" element={<Research />} />
        <Route path="/trade" element={<BggTrade />} />
      </Routes>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {!isGridExpanded && <Footer />}
    </div>
  );
}

function App() {
  return (
    <GlobalStateProvider>
      <Router>
        <AppContent />
      </Router>
    </GlobalStateProvider>
  );
}

export default App;
